import Notifications from 'components/Notifications/Index'
import NotificationEditor from 'components/Notifications/Editor'
import Main from 'components/Main/Index'
import Software from 'components/Software/Index'
import Services from 'components/Services/Index'
import Promos from 'components/Promos/Index'
import SoftwarePackage from 'components/Software/Package'
import About from 'components/About/Index'
import Events from 'components/Events/Events'
import EditEvent from 'components/Events/EditEvent'
import EmitentNews from 'components/EmitentNews/Index'
import EmitentNewsEditor from 'components/EmitentNews/Editor'
import Accounts from 'components/Accounts/Index'
import ServiceRequests from 'components/ServiceRequests/Index'
import Settings from 'components/Settings/Index'
import AdditionalPages from 'components/AdditionalPages/Index'
import AdditionalPage from 'components/AdditionalPages/AdditionalPage'
import EventsRequests from 'components/Events/EventsRequests'
import Partners from 'components/Partners/Index'
import PartnerEditor from 'components/Partners/Editor'
import BrandHistory from 'components/BrandHistory/Index'
import IndividualInvestment from 'components/IndividualInvestment/Index'
import Files from 'components/Files'
import Loans from 'components/BondedLoan/Loans'
import Redirects from 'components/Redirects/Index'
import MetaTags from 'components/MetaTags/Index'
import FinancialClubInfo from 'components/FinancialClubInfo/Index'

import Underwriting from 'components/Underwriting/Index'
import Test from 'components/Test/Index'
import Uprid from 'components/Uprid/Index'
import M2MSchedule from 'components/M2MSchedule/Index'

import EventsRoutes from './EventsRoutes'
import AboutRoutes from './AboutRoutes'
import HistoryRoutes from './HistoryRoutes'
import LoanRoutes from './LoanRoutes'

export default {
  children: [
    {
      path: '/main',
      name: 'Main',
      component: Main
    },
    {
      path: '/services',
      name: 'Services',
      component: Services,
      children: [
        {
          path: ':id',
          name: 'Service',
          component: Services
        }
      ]
    },
    {
      path: '/stocks',
      name: 'Promos',
      component: Promos
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: 'events',
      name: 'AllEvents',
      component: Events,
      children: EventsRoutes.children
    },
    {
      path: '/events/event/:id',
      name: 'Event',
      component: EditEvent
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      children: AboutRoutes.children
    },
    {
      path: '/additional-pages',
      name: 'AdditionalPages',
      component: AdditionalPages,
      children: [
        {
          path: ':id',
          name: 'AdditionalPage',
          component: AdditionalPage
        }
      ]
    },
    {
      path: '/service-requests',
      name: 'ServiceRequests',
      component: ServiceRequests
    },
    {
      path: '/emitent-news',
      name: 'EmitentNews',
      component: EmitentNews
    },
    {
      path: '/emitent-news/edit/:id',
      name: 'EmitentNewsEditor',
      component: EmitentNewsEditor
    },
    {
      path: '/emitent-news/create',
      name: 'EmitentNewsCreator',
      component: EmitentNewsEditor
    },
    {
      path: '/notifications/',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: '/notifications/:id',
      name: 'NotificationEditor',
      component: NotificationEditor
    },
    {
      path: 'software',
      name: 'Software',
      component: Software
    },
    {
      path: '/software/:id',
      name: 'SoftEditor',
      component: SoftwarePackage
    },
    {
      path: '/accounts',
      name: 'Accounts',
      component: Accounts
    },
    {
      path: '/events-requests',
      name: 'EventsRequests',
      component: EventsRequests
    },
    {
      path: '/partners',
      name: 'Partners',
      component: Partners
    },
    {
      path: '/partners/:id',
      name: 'PartnerEditor',
      component: PartnerEditor
    },
    {
      path: '/history',
      name: 'BrandHistory',
      component: BrandHistory,
      redirect: '/history/reviews',
      children: HistoryRoutes.children
    },
    {
      path: '/files',
      name: 'Files',
      component: Files
    },
    {
      path: '/investment',
      name: 'IndividualInvestment',
      component: IndividualInvestment
    },
    {
      path: '/loans',
      name: 'Loans',
      component: Loans,
      children: LoanRoutes.children
    },
    {
      path: '/redirects',
      name: 'Redirects',
      component: Redirects
    },
    {
      path: '/metatags',
      name: 'MetaTags',
      component: MetaTags
    },
    {
      path: '/fclub',
      name: 'FinancialClubInfo',
      component: FinancialClubInfo
    },
    {
      path: '/underwriting',
      name: 'Underwriting',
      component: Underwriting
    },
    {
      path: '/test',
      name: 'Test',
      component: Test
    },
    {
      path: '/uprid',
      name: 'Uprid',
      component: Uprid
    },
    {
      path: '/m2m-schedule',
      name: 'M2MSchedule',
      component: M2MSchedule
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/IndexPageRoutes.js